/* app/js/src/components/common/day-of-week-picker/day-of-week-picker.component.scss */
icn-dropdown {
  width: 120px;
}
/*# sourceMappingURL=day-of-week-picker.component.css.map */
